import { BindAll } from 'lodash-decorators'
import { EnumApiAbout } from '../../api'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { Pagination } from '../basics/pagination'

@BindAll()
export class ControllerAbout {
  constructor(protected $ajax: AjaxBasics) {}

  /**
   * 数据转换
   * @memberof ControllerAbout
   */
  onMapValues(res) {
    return { dataSource: res.data }
  }

  /**
   * 分页列表数据 (已弃用)
   * @memberof ControllerAbout
   * @deprecated
   */
  Pagination = new Pagination(this.$ajax, {
    url: EnumApiAbout.AboutList,
    key: 'id',
    onMapValues: this.onMapValues
  })

  /**
   * 分页列表数据v2
   * @memberof ControllerAbout
   */
  pagePagination = new PagePagination({
    url: EnumApiAbout.AboutList,
    mapValues: res => {
      const { data } = res
      return {
        dataSource: data
      }
    }
  })

  /**
   * 增加文章浏览量
   */
  async onAboutViewAdd(id) {
    const res = await this.$ajax.put(EnumApiAbout.AboutViewAdd, { id })
    return res
  }
}
export default ControllerAbout
